import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
    saveRequisitionChanges,
    generateUniqueKey,
    createRequisitionPDF,
    fetchDiagnosisCodesList
} from '../../../services/clinicPortalServices/requisitionService';
import { createInsurance } from '../../../services/clinicPortalServices/patientInsuranceService';
import { patientSignup } from '../../../services/patientSignupServices/patientSignupFormService';
import { fetchPhysiciansUnlocked } from '../../../services/clinicPortalServices/physicianServices';
import { fetchFacilitiesForOrders } from '../../../services/clinicPortalServices/facilityServices';
import { fetchPatientWithQuery } from '../../../services/clinicPortalServices/patientSearchService';
import { serviceConstants } from '../../../services/common/constants';
import moment from 'moment';
import { identity, ethnicity, race, relation, states, specimenTypes } from '../../../services/common/optionsData';
import { getUserAuthToken, getUserFullName, isValidEmail, isValidPhoneNumber } from '../../../services/common/util';
import { MobileDateTimePicker, MobileDatePicker } from '@mui/x-date-pickers';
import {
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
    TextField,
    Checkbox,
    MenuItem,
    Select,
    InputLabel,
    Autocomplete,
    InputAdornment,
    IconButton
} from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import Barcode from 'react-barcode';
import BarcodeScanner from '../patients/barcodeScanner';
import { phoneNumberFormatter, checkValidityLicense, getUserDetails } from '../../../services/common/util';
import { updatePatientData } from '../../../services/clinicPortalServices/patientEditService';
import Swal from 'sweetalert2';
import _ from 'lodash';
import { getAllInsuranceProviders } from '../../../services/clinicPortalServices/insuranceProviderSerivce';
import { getAllTests } from '../../../services/clinicPortalServices/testService';
import { ModalStyled } from '../../../theme/customizedStyleComponents';
import store from '../../../redux/store';
import actions from '../../../redux/actions';
import { bindActions } from 'redux-zero/utils';
import { createMedication, fetchMedications } from '../../../services/clinicPortalServices/medicationService';
import toastr from 'toastr';
import { getSettings } from '../../../services/clinicPortalServices/settingService';

const boundActions = bindActions(actions, store);

export default class CreateToxicologyRequisition extends Component {
    constructor(props) {
        super(props);

        let collectorName = '';
        if (getUserDetails()) {
            const userInfo = JSON.parse(getUserDetails());
            collectorName = userInfo.first_name + ' ' + userInfo.last_name;
        }
        this.state = {
            allDiagnosisCodes: [],
            facilities: [],
            facilityId: '',
            facilityName: '',
            facilityAddress: {},
            facilityPhone: '',
            facilityDetails: {},
            providers: [],
            selectedProviderId: '',
            providerFirstName: '',
            providerLastName: '',
            providerNPI: '',
            providerSignatureImage: '',
            collectorName: collectorName,
            collectedDate: moment().format('MM/DD/YYYY hh:mm A'),
            respondedSample: '',
            sampleObjects: [
                {
                    specimenType: '',
                    sample: '',
                    medications: [
                        {
                            medication: '',
                            diagnosisCodes: ['']
                        }
                    ],
                    testObjects: [
                        {
                            testId: '',
                            testDetails: {},
                            testInfoCode: '',
                            testInfoDescription: '',
                            diagnosisCode: [],
                            symptoms: []
                        }
                    ]
                }
            ],
            step: 'beforePatient',
            patients: [],
            patientCase: 'existing',
            existingPatient: {},
            checkPatient: false,
            patientFirstName: '',
            patientLastName: '',
            gender: 'U',
            phoneNumber: '',
            email: '',
            is_pregnant: false,
            dateOfBirth: moment().format('MM/DD/YYYY'),
            ethnicity: '',
            race: '',
            address1: '',
            address2: '',
            state: '',
            city: '',
            zip: '',
            passport: '',
            customInfo: '',
            errors: [],
            insurances: [],
            selectedInsurance: '',
            insuranceId: '',
            insuranceProv1: '',
            insuranceProv2: '',
            memberId: '',
            groupNumber: '',
            relation: '',
            insuredFirstName: '',
            insuredLastName: '',
            driverLicense: '',
            driverLicenseState: '',
            socialSecurityNumber: '',
            checkedSign: false,
            saving: false,
            showDatePickerError: false,
            showPrintModal: false,
            insuranceProviders: [],
            allTests: [],
            allMedications: [],
            loadingMedications: false,
            is_show_diagnosis_code_for_tests_create_requisition: false,
            is_show_diagnosis_code_for_medications_create_requisition: false,
            is_show_collector_name_create_requisition: false
        };
        getAllTests({ type: 'all' }).then((res) => {
            this.setState({ allTests: res.data });
        });
    }

    componentDidMount() {
        getAllInsuranceProviders().then((res) => {
            this.setState({
                insuranceProviders: [
                    'Self/Pay',
                    'Other',
                    ...res.data
                        .filter((item) => item.name !== 'NO INSURANCE')
                        .map((item) => {
                            return item.name;
                        })
                ]
            });
        });

        // Load medications
        this.loadMedications();
    }

    loadMedications = () => {
        this.setState({ loadingMedications: true });
        fetchMedications()
            .then((res) => {
                if (res.data) {
                    this.setState({
                        allMedications: res.data,
                        loadingMedications: false
                    });
                }
            })
            .catch((error) => {
                console.error('Error loading medications:', error);
                this.setState({ loadingMedications: false });
            });
    };

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    loadDataForModal = () => {
        fetchFacilitiesForOrders().then((res) => {
            let facilities;
            if (this.props.testId) {
                facilities = res.data.filter((item) =>
                    item.testIds.find(
                        (test) =>
                            test._id === this.props.testId ||
                            (test.testIds &&
                                test.testIds.length &&
                                test.testIds.find((testId) => testId === this.props.testId))
                    )
                );
                let testDetails = this.state.allTests.find((item) => item._id === this.props.testId);
                this.setState(
                    {
                        testDetails: testDetails,
                        specimenType: testDetails.specimenType
                    },
                    () => {
                        this.setTestInfo();
                    }
                );
            } else {
                facilities = res.data;
            }

            this.setState({
                facilities: facilities,
                facilityId: facilities[0]._id,
                facilityName: facilities[0].name,
                facilityAddress: facilities[0].address,
                facilityPhone: facilities[0].phone_no,
                facilityDetails: facilities[0]
            });
            this.getPhysicians(facilities[0]._id);
        });
        fetchDiagnosisCodesList().then((res) => {
            this.setState({ allDiagnosisCodes: res.data });
        });
        getSettings().then((response) => {
            if (response && response.data) {
                this.setState(
                    {
                        is_show_diagnosis_code_for_tests_create_requisition:
                            response.data.is_show_diagnosis_code_for_tests_create_requisition,
                        is_show_diagnosis_code_for_medications_create_requisition:
                            response.data.is_show_diagnosis_code_for_medications_create_requisition,
                        is_show_collector_name_create_requisition:
                            response.data.is_show_collector_name_create_requisition,
                        default_specimen_type: response.data.default_specimen_type
                    },
                    () => {
                        if (this.state.default_specimen_type) {
                            this.setState({
                                sampleObjects: [
                                    { ...this.state.sampleObjects[0], specimenType: this.state.default_specimen_type }
                                ]
                            });
                        }
                    }
                );
            }
        });
    };

    getPhysicians = (facilityId) => {
        fetchPhysiciansUnlocked(facilityId).then((response) => {
            this.setState({
                providers: response.data
            });
            if (response.data.length) {
                this.setState({
                    selectedProviderId: response.data[0]._id,
                    providerFirstName: response.data[0].first_name,
                    providerLastName: response.data[0].last_name,
                    providerNPI: response.data[0].npi,
                    providerSignatureImage: response.data[0].signature_image
                });
            } else {
                this.setState({
                    selectedProviderId: '',
                    providerFirstName: '',
                    providerLastName: '',
                    providerNPI: '',
                    providerSignatureImage: ''
                });
            }
        });
    };

    getPatients = (facilityId, extraFilters = null) => {
        boundActions.startBlockUILoading();
        let patientsQuery = {
            facility_id: facilityId,
            first_name: extraFilters.firstName.trim(),
            last_name: extraFilters.lastName.trim()
        };
        fetchPatientWithQuery(patientsQuery).then((response) => {
            boundActions.endBlockUILoading();
            if (response.data) {
                let patients = response.data;
                let patientCase;
                if (patients.length) {
                    patientCase = 'existing';
                } else {
                    patientCase = 'new';
                }
                this.setState({
                    patients: patients,
                    patientCase: patientCase,
                    checkPatient: true
                });
            }
        });
    };

    initPatient = (isNewPatientOption = false) => {
        let patientFirstName, patientLastName, checkPatient;
        if (isNewPatientOption) {
            patientFirstName = this.state.patientFirstName;
            patientLastName = this.state.patientLastName;
            checkPatient = true;
        } else {
            patientFirstName = '';
            patientLastName = '';
            checkPatient = false;
        }
        this.setState({
            existingPatient: {},
            patientFirstName: patientFirstName,
            patientLastName: patientLastName,
            gender: 'U',
            phoneNumber: '',
            email: '',
            is_pregnant: false,
            dateOfBirth: moment().format('MM/DD/YYYY'),
            ethnicity: '',
            race: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            passport: '',
            customInfo: '',
            errors: [],
            insurances: [],
            selectedInsurance: '',
            insuranceId: '',
            insuranceProv1: '',
            insuranceProv2: '',
            memberId: '',
            groupNumber: '',
            relation: '',
            insuredFirstName: '',
            insuredLastName: '',
            driverLicense: '',
            driverLicenseState: '',
            socialSecurityNumber: '',
            checkedSign: false,
            checkPatient: checkPatient
        });
    };

    handleChange = (e) => {
        if (e.target.name === 'phoneNumber') {
            this.setState({
                phoneNumber: phoneNumberFormatter(e.target.value)
            });
        } else {
            this.setState({ [e.target.name]: e.target.value });
        }
        if (e.target.name === 'facilityId') {
            const facility = this.state.facilities.filter((fac) => fac._id === e.target.value)[0];
            this.setState({
                facilityName: facility.name,
                facilityAddress: facility.address,
                facilityPhone: facility.phone_no,
                facilityDetails: facility
            });
            this.getPhysicians(e.target.value);
            this.initPatient();
        }
        if (e.target.name === 'selectedProviderId') {
            let index = this.state.providers.findIndex((i) => i._id === e.target.value);
            if (index > -1) {
                this.setState({
                    providerFirstName: this.state.providers[index].first_name,
                    providerLastName: this.state.providers[index].last_name,
                    providerNPI: this.state.providers[index].npi,
                    providerSignatureImage: this.state.providers[index].signature_image
                });
            }
        }
        if (e.target.name === 'patientCase') {
            this.initPatient(e.target.value === 'new' ? true : false);
        }
        if (this.state.errors.includes(e.target.name) && e.target.value) {
            let errors = [];
            if (/socialSecurityNumber|driverLicense/.test(e.target.name) && e.target.value) {
                errors = this.state.errors.filter((error) => !/socialSecurityNumber|driverLicense/.test(error));
            } else {
                errors = this.state.errors.filter((error) => error !== e.target.name);
            }
            this.setState({ errors: errors });
        }
    };

    handleChangeSampleObject = (e, sampleObjectIndex) => {
        let sampleObjects = this.state.sampleObjects;
        sampleObjects.map((item, i) => {
            if (i === sampleObjectIndex) {
                item[e.target.name] = e.target.value;
                if (e.target.name === 'specimenType') {
                    item.testObjects = [
                        {
                            testId: '',
                            testDetails: {},
                            testInfoCode: '',
                            testInfoDescription: '',
                            diagnosisCode: [],
                            symptoms: []
                        }
                    ];
                }
            }
            return null;
        });
        this.setState({ sampleObjects: sampleObjects });
    };

    handleChangeMedicationObject = (e, sampleObjectIndex, medicationIndex, diagnosisCodeIndex) => {
        let sampleObjects = this.state.sampleObjects;
        sampleObjects.map((sampleObject, i) => {
            if (i === sampleObjectIndex) {
                sampleObject.medications.map((medicationItem, medicationItemIndex) => {
                    if (medicationIndex === medicationItemIndex) {
                        if (e.target.name === 'medication') {
                            medicationItem.medication = e.target.value;
                        } else if (e.target.name === 'diagnosisCode') {
                            medicationItem.diagnosisCodes = medicationItem.diagnosisCodes.map(
                                (codeItem, codeItemIndex) => {
                                    if (codeItemIndex === diagnosisCodeIndex) {
                                        codeItem = e.target.value;
                                    }
                                    return codeItem;
                                }
                            );
                        }
                    }
                    return null;
                });
            }
            return null;
        });
        this.setState({ sampleObjects: sampleObjects });
    };

    handleMedicationAutocompleteChange = async (value, sampleObjectIndex, medicationIndex) => {
        let sampleObjects = [...this.state.sampleObjects];

        if (sampleObjectIndex < sampleObjects.length) {
            const sampleObject = sampleObjects[sampleObjectIndex];
            if (medicationIndex < sampleObject.medications.length) {
                // If value is a string (new medication), create it first
                if (typeof value === 'string' && value.trim()) {
                    try {
                        const newMedication = {
                            name: value.trim(),
                            description: value.trim(),
                            createdBy: getUserFullName()
                        };

                        const response = await createMedication(newMedication);
                        if (response.status === 201 && response.data) {
                            // Add the new medication to our list
                            this.setState((prevState) => ({
                                allMedications: [...prevState.allMedications, response.data]
                            }));

                            // Set the medication ID
                            sampleObject.medications[medicationIndex].medication = response.data._id;
                            sampleObject.medications[medicationIndex].medicationName = response.data.name;

                            toastr.success(`New medication "${value}" created successfully`);
                        }
                    } catch (error) {
                        console.error('Error creating medication:', error);
                        toastr.error('Failed to create new medication');
                        return;
                    }
                } else if (value && value._id) {
                    // Existing medication selected
                    sampleObject.medications[medicationIndex].medication = value._id;
                    sampleObject.medications[medicationIndex].medicationName = value.name;
                } else {
                    // Clear selection
                    sampleObject.medications[medicationIndex].medication = '';
                    sampleObject.medications[medicationIndex].medicationName = '';
                }

                this.setState({ sampleObjects });
            }
        }
    };

    handleChangeTestObject = (e, sampleObjectIndex, testObjectIndex) => {
        let sampleObjects = this.state.sampleObjects;
        sampleObjects.map((sampleObject, i) => {
            if (i === sampleObjectIndex) {
                sampleObject.testObjects.map((testObject, testObjectIndexForMapping) => {
                    if (testObjectIndex === testObjectIndexForMapping) {
                        testObject[e.target.name] = e.target.value;
                        if (e.target.name === 'testId') {
                            let testDetails = {};
                            if (this.state.facilityDetails.testIds && this.state.facilityDetails.testIds.length) {
                                testDetails = this.state.facilityDetails.testIds.find(
                                    (item) => item._id === e.target.value
                                );
                            }
                            testObject.testDetails = testDetails;
                            testObject.testInfoCode = testDetails ? testDetails.code : '';
                            testObject.testInfoDescription = testDetails ? testDetails.description : '';
                            testObject.diagnosisCode = [];
                            testObject.symptoms = [];
                        }
                    }
                    return null;
                });
            }
            return null;
        });
        this.setState({ sampleObjects: sampleObjects });
    };

    handleSelectInsurance = (e) => {
        this.setState({
            selectedInsurance: e.target.value,
            errors: this.state.errors.filter((error) => error !== 'noInsurance')
        });
        let insuranceDetails = {};
        this.state.insurances.map((insurance) => {
            if (insurance._id === e.target.value) {
                insuranceDetails = _.cloneDeep(insurance);
            }
            return null;
        });
        if (insuranceDetails._id) {
            let flag = true;
            this.state.insuranceProviders.map((item) => {
                if (item.value === insuranceDetails.insurance_provider) {
                    flag = false;
                }
                return null;
            });
            if (flag) {
                insuranceDetails.insurance_provider2 = insuranceDetails.insurance_provider;
                insuranceDetails.insurance_provider = 'Other';
            }
            this.setState({
                insuranceId: insuranceDetails._id ? insuranceDetails._id : '',
                insuranceProv1: insuranceDetails.insurance_provider ? insuranceDetails.insurance_provider : '',
                insuranceProv2: insuranceDetails.insurance_provider2 ? insuranceDetails.insurance_provider2 : '',
                memberId: insuranceDetails.insured_member_id ? insuranceDetails.insured_member_id : '',
                groupNumber: insuranceDetails.insured_group_number ? insuranceDetails.insured_group_number : '',
                relation: insuranceDetails.relation_to_insured ? insuranceDetails.relation_to_insured : '',
                insuredFirstName: insuranceDetails.insured_first_name ? insuranceDetails.insured_first_name : '',
                insuredLastName: insuranceDetails.insured_last_name ? insuranceDetails.insured_last_name : '',
                socialSecurityNumber: insuranceDetails.social_security_number
                    ? insuranceDetails.social_security_number
                    : ''
            });
        } else {
            this.setState({
                insuranceId: '',
                insuranceProv1: '',
                insuranceProv2: '',
                memberId: '',
                groupNumber: '',
                relation: '',
                insuredFirstName: '',
                insuredLastName: '',
                socialSecurityNumber: ''
            });
        }
    };

    togglePregnancy = () => {
        this.setState({ is_pregnant: !this.state.is_pregnant });
    };

    toggleCheckedSign = () => {
        if (!this.state.checkedSign) {
            this.setState({ errors: [] });
        } else {
            this.setState({ errors: ['checkedSign'] });
        }
        this.setState({ checkedSign: !this.state.checkedSign });
    };

    handleCheckPatient = () => {
        let errors = [];
        if (!this.state.patientFirstName) {
            errors.push('patientFirstName');
        }
        if (!this.state.patientLastName) {
            errors.push('patientLastName');
        }
        if (errors.length) {
            this.setState({ errors: errors });
        } else {
            const extraFilters = {
                firstName: this.state.patientFirstName,
                lastName: this.state.patientLastName
            };
            this.getPatients(this.state.facilityId, extraFilters);
        }
    };

    handleClearCheckPatient = () => {
        this.setState({
            checkPatient: false
        });
        this.initPatient();
    };

    autoGenerateKey = (sampleObjectIndex) => {
        generateUniqueKey().then((response) => {
            let sampleObjects = this.state.sampleObjects;
            sampleObjects.map((sampleObject, index) => {
                if (index === sampleObjectIndex) {
                    sampleObject.sample = response.data;
                }
                return null;
            });
            this.setState({
                sampleObjects: sampleObjects,
                respondedSample: response.data,
                showGeneratedBarcode: true
            });
        });
    };

    handleDateFiltersChange = (dateTime, type) => {
        if (type === 'collectedDate') {
            this.setState({ collectedDate: dateTime });
        } else if (type === 'dateOfBirth') {
            this.setState({ dateOfBirth: dateTime });
            if (moment(dateTime).format('YYYYMMDD') !== moment().format('YYYYMMDD')) {
                this.setState({ showDatePickerError: false });
            }
        }
    };

    handleClose = () => {
        this.props.handleClose();
        let collectorName = '';
        if (getUserDetails()) {
            const userInfo = JSON.parse(getUserDetails());
            collectorName = userInfo.first_name + ' ' + userInfo.last_name;
        }
        this.setState({
            facilities: [],
            facilityId: '',
            facilityName: '',
            facilityAddress: {},
            facilityPhone: '',
            providers: [],
            selectedProviderId: '',
            providerFirstName: '',
            providerLastName: '',
            providerNPI: '',
            providerSignatureImage: '',
            collectorName: collectorName,
            collectedDate: moment().format('MM/DD/YYYY hh:mm A'),
            respondedSample: '',
            sampleObjects: [
                {
                    specimenType: '',
                    sample: '',
                    medications: [
                        {
                            medication: '',
                            diagnosisCodes: ['']
                        }
                    ],
                    testObjects: [
                        {
                            testId: '',
                            testDetails: {},
                            testInfoCode: '',
                            testInfoDescription: '',
                            diagnosisCode: [],
                            symptoms: []
                        }
                    ]
                }
            ],
            step: 'beforePatient',
            errors: [],
            patients: [],
            patientCase: 'existing',
            showPrintModal: false,
            checkPatient: false
        });

        this.initPatient();
    };

    handleBack = () => {
        if (this.state.step === 'beforePatient') {
            this.handleClose();
        } else if (this.state.step === 'selectPatient') {
            this.setState({ step: 'beforePatient' });
        } else if (this.state.step === 'selectInsurance') {
            this.setState({ step: 'selectPatient' });
        } else {
            this.setState({ step: 'selectInsurance' });
        }
    };

    checkValidSecurityNumber = () => {
        let isValidSecurityNumber = checkValidityLicense(this.state.socialSecurityNumber);
        if (!isValidSecurityNumber && this.state.socialSecurityNumber) {
            Swal.fire({
                title: 'Invalid Social Security Number',
                text:
                    'This looks like an invalid social security number.  It is required for using the ' +
                    this.state.insuranceProv1 +
                    '.  Please ensure it is entered correctly.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Try again',
                cancelButtonText: 'Allow it',
                customClass: {
                    container:
                        window.localStorage.getItem('appTheme') === 'Dark' &&
                        /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                        'dark-swal',
                    cancelButton: 'order-1',
                    confirmButton: 'order-2'
                }
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.setState({ step: 'afterInsurance', errors: [] });
                }
            });
        } else {
            this.setState({ step: 'afterInsurance', errors: [] });
        }
    };
    checkValidDriverLicense = () => {
        let isValidDriverLicense = checkValidityLicense(this.state.driverLicense);
        if (!isValidDriverLicense && this.state.driverLicense) {
            Swal.fire({
                title: 'Invalid Driver License',
                text: 'This looks like an invalid drivers license. A Drivers License is required to accept insurance. Without the drivers license the order may not be able to be processed by the billing company, in which case we will inform you of the error and you can correct it at that time.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Try again',
                cancelButtonText: 'Allow it',
                customClass: {
                    container:
                        window.localStorage.getItem('appTheme') === 'Dark' &&
                        /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                        'dark-swal',
                    cancelButton: 'order-1',
                    confirmButton: 'order-2'
                }
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.checkValidSecurityNumber();
                }
            });
        } else {
            this.checkValidSecurityNumber();
        }
    };

    handleNext = () => {
        if (this.state.step === 'beforePatient') {
            let errors = [];
            if (!this.state.selectedProviderId) {
                errors.push('selectedProviderId');
            }
            if (!this.state.collectorName && this.state.is_show_collector_name_create_requisition) {
                errors.push('collectorName');
            }
            if (
                !this.state.collectedDate ||
                (this.state.collectedDate &&
                    moment(this.state.collectedDate).format('YYYYMMDDHHmmss') === 'Invalid date')
            ) {
                errors.push('collectedDate');
            }
            this.state.sampleObjects.map((sampleObject, sampleObjectIndex) => {
                if (!sampleObject.sample) {
                    errors.push('sample' + sampleObjectIndex);
                }
                if (sampleObject.sample && sampleObject.sample.length < 6) {
                    errors.push('sampleLength' + sampleObjectIndex);
                }
                sampleObject.medications.map((medicationItem) => {
                    if (!medicationItem.medication && medicationItem.diagnosisCodes.find((item) => item)) {
                        toastr.error('Please fill medication correctly');
                        errors.push('medication');
                    }
                    return null;
                });
                sampleObject.testObjects.map((testObject, testObjectIndex) => {
                    if (!testObject.testId) {
                        errors.push('testId' + sampleObjectIndex.toString() + testObjectIndex.toString());
                    }
                    // if (!testObject.diagnosisCode.length) {
                    //     errors.push('diagnosisCode' + sampleObjectIndex.toString() + testObjectIndex.toString());
                    // }
                    return null;
                });
                return null;
            });
            if (errors.length) {
                this.setState({ errors: errors });
            } else {
                this.setState({ step: 'selectPatient', errors: [] });
            }
        } else if (this.state.step === 'selectPatient') {
            let errors = [];
            if (this.state.patientCase === 'existing') {
                if (!this.state.existingPatient._id) {
                    errors.push('existingPatient');
                }
            }
            if (!this.state.patientFirstName) {
                errors.push('patientFirstName');
            }
            if (!this.state.patientLastName) {
                errors.push('patientLastName');
            }
            if (this.state.email && !isValidEmail(this.state.email)) {
                errors.push('wrongEmail');
            }
            if (this.state.phoneNumber && !isValidPhoneNumber(this.state.phoneNumber)) {
                errors.push('wrongPhoneNumber');
            }
            if (!this.state.phoneNumber && !this.state.email) {
                errors.push('phoneNumberOrEmail');
            }
            if (!this.state.address1) {
                errors.push('address1');
            }
            if (!this.state.city) {
                errors.push('city');
            }
            if (!this.state.state) {
                errors.push('state');
            }
            if (!this.state.zip) {
                errors.push('zip');
            }
            if (moment(this.state.dateOfBirth).format('YYYYMMDD') === 'Invalid date') {
                errors.push('dateOfBirth');
            }

            if (errors.length) {
                this.setState({ errors: errors });
            } else {
                if (moment(this.state.dateOfBirth).format('YYYYMMDD') === moment().format('YYYYMMDD')) {
                    Swal.fire({
                        customClass: {
                            container:
                                window.localStorage.getItem('appTheme') === 'Dark' &&
                                /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                                'dark-swal'
                        },
                        title: 'Birthday Error',
                        text: "Birthdate can not be today's date.",
                        icon: 'warning',
                        confirmButtonText: 'Close'
                    }).then((result) => {
                        this.setState({ showDatePickerError: true });
                        return;
                    });
                    return;
                }
                this.setState({ step: 'selectInsurance', errors: [] });
            }
        } else if (this.state.step === 'selectInsurance') {
            let errors = [];
            if (!this.state.selectedInsurance) {
                errors.push('noInsurance');
            } else {
                if (this.state.selectedInsurance === 'new') {
                    if (!this.state.insuranceProv1 && !this.state.insuranceProv2) {
                        errors.push('noInsuranceProvider');
                    }
                    if (
                        this.state.insuranceProv1 &&
                        this.state.insuranceProv1.toLowerCase() === 'other' &&
                        !this.state.insuranceProv2
                    ) {
                        errors.push('noInsuranceProvider2');
                    }
                    if (this.state.insuranceProv1 !== 'Self/Pay') {
                        if (!this.state.memberId) {
                            errors.push('memberId');
                        }
                        if (!this.state.groupNumber) {
                            errors.push('groupNumber');
                        }
                        if (!this.state.relation) {
                            errors.push('relation');
                        }
                        if (this.state.relation !== 'Self' && !this.state.insuredFirstName) {
                            errors.push('insuredFirstName');
                        }
                        if (this.state.relation !== 'Self' && !this.state.insuredLastName) {
                            errors.push('insuredLastName');
                        }
                    }
                }
            }
            if (errors.length) {
                this.setState({ errors: errors });
            } else {
                if (this.state.selectedInsurance === 'new') {
                    this.checkValidDriverLicense();
                } else {
                    this.setState({ step: 'afterInsurance' });
                }
            }
        } else {
            let errors = [];
            if (!this.state.checkedSign) {
                errors.push('checkedSign');
            }
            if (errors.length) {
                this.setState({ errors: errors });
            } else {
                this.setState({ saving: true, errors: [] });
                boundActions.startBlockUILoading();
                if (this.state.patientCase === 'existing') {
                    // update patient info
                    const editParams = {
                        _id: this.state.existingPatient._id,
                        firstName: this.state.patientFirstName,
                        lastName: this.state.patientLastName,
                        dob: moment(this.state.dateOfBirth).format('YYYY-MM-DD'),
                        gender: this.state.gender,
                        email: this.state.email,
                        mobile: this.state.phoneNumber,
                        address1: this.state.address1,
                        address2: this.state.address2,
                        city: this.state.city,
                        state: this.state.state,
                        zip: this.state.zip,
                        passport: this.state.passport,
                        custom_info: this.state.customInfo,
                        country: 'US',
                        ethnicity: this.state.ethnicity,
                        race: this.state.race,
                        is_pregnant: this.state.is_pregnant
                    };
                    if (this.state.driverLicense) {
                        editParams.driverLicense = this.state.driverLicense;
                        editParams.driverLicenseState = this.state.driverLicenseState;
                    }
                    updatePatientData(editParams).then(async (userDetails) => {
                        let insuranceId;
                        // create patient insurance
                        let insuranceDetails = {
                            insuranceId: this.state.insuranceId,
                            insuranceProv1: this.state.insuranceProv1,
                            insuranceProv2: this.state.insuranceProv2,
                            memberId: this.state.memberId,
                            groupNumber: this.state.groupNumber,
                            relation: this.state.relation,
                            insuredFirstName: this.state.insuredFirstName,
                            insuredLastName: this.state.insuredLastName,
                            socialSecurityNumber: this.state.socialSecurityNumber,
                            patientId: this.state.existingPatient._id
                        };
                        if (this.state.insuranceId) {
                            insuranceId = this.state.insuranceId;
                        } else {
                            let createInsurancePromise = new Promise((resolve, reject) => {
                                createInsurance(insuranceDetails).then((response) => {
                                    resolve(response.data._id);
                                });
                            });
                            insuranceId = await createInsurancePromise;
                        }
                        // create requisition
                        this.createToxicologyRequisition(
                            this.state.existingPatient._id,
                            this.state.existingPatient.mrn,
                            insuranceId
                        );
                    });
                } else {
                    // create patient and insurance
                    const patientInfo = {
                        firstName: this.state.patientFirstName,
                        lastName: this.state.patientLastName,
                        email: this.state.email,
                        phone: this.state.phoneNumber,
                        sex: this.state.gender,
                        dob: moment(this.state.dateOfBirth).format('YYYY-MM-DD'),
                        ethnicity: this.state.ethnicity,
                        race: this.state.race,
                        address1: this.state.address1,
                        address2: this.state.address2,
                        city: this.state.city,
                        state: this.state.state,
                        zip: this.state.zip,
                        passport: this.state.passport,
                        custom_info: this.state.customInfo,
                        symptoms: this.state.symptoms,
                        facilityId: this.state.facilityId,
                        is_pregnant: this.state.is_pregnant,
                        notify: false
                    };
                    if (this.state.selectedInsurance === 'new') {
                        patientInfo.insuranceProv1 = this.state.insuranceProv1;
                        patientInfo.insuranceProv2 = this.state.insuranceProv2;
                        patientInfo.memberId = this.state.memberId;
                        patientInfo.groupNumber = this.state.groupNumber;
                        patientInfo.relation = this.state.relation;
                        patientInfo.insuranceId = this.state.insuranceId;
                        patientInfo.insuredFirstName = this.state.insuredFirstName;
                        patientInfo.insuredLastName = this.state.insuredLastName;
                        patientInfo.driverLicense = this.state.driverLicense;
                        patientInfo.driverLicenseState = this.state.driverLicenseState;
                        patientInfo.socialSecurityNumber = this.state.socialSecurityNumber;
                    }
                    patientSignup(patientInfo).then((response) => {
                        if (response.data && response.data.length) {
                            const patient = response.data[0];
                            let insuranceId = null;
                            if (response.data && response.data[1] && response.data[1]._id) {
                                insuranceId = response.data[1]._id;
                            }
                            // create requisition
                            this.createToxicologyRequisition(patient._id, patient.mrn, insuranceId);
                        }
                    });
                }
            }
        }
    };

    createToxicologyRequisition = async (patientId, patientMrn, insuranceId) => {
        let orderIds = [];
        let allMedications = [];
        let sampleObjects = this.state.sampleObjects;
        for (let i = 0; i < sampleObjects.length; i++) {
            let medicationIds = [];
            for (let j = 0; j < sampleObjects[i].medications.length; j++) {
                let medication = sampleObjects[i].medications[j];
                // Use the medication ID directly since it's already been created/selected
                if (medication.medication) {
                    medicationIds.push(medication.medication);
                }
            }
            let testObjects = sampleObjects[i].testObjects;
            for (let j = 0; j < testObjects.length; j++) {
                let subOrderIds = [];
                if (testObjects[j].testDetails.isPanel) {
                    for (let k = 0; k < testObjects[j].testDetails.testIds.length; k++) {
                        let testId = testObjects[j].testDetails.testIds[k];
                        let testDetails = {};
                        this.state.allTests.map((test) => {
                            if (test._id === testId) {
                                testDetails = test;
                            }
                            return null;
                        });
                        let reqInfo = this.getParamsForRequisition(
                            patientId,
                            sampleObjects[i].sample,
                            testObjects[j],
                            testDetails,
                            'sub_panel'
                        );
                        if (insuranceId) {
                            reqInfo.patientInsuranceId = insuranceId;
                        }
                        if (medicationIds && medicationIds.length) {
                            reqInfo.medicationIds = medicationIds;
                        }
                        let createSubPanelPromise = new Promise((resolve, reject) => {
                            saveRequisitionChanges(reqInfo)
                                .then((response) => {
                                    resolve(response.data._id);
                                })
                                .catch((error) => {
                                    reject(error);
                                });
                        });
                        let orderId = await createSubPanelPromise;
                        subOrderIds.push(orderId);
                    }
                }
                let reqInfo = this.getParamsForRequisition(
                    patientId,
                    sampleObjects[i].sample,
                    testObjects[j],
                    testObjects[j].testDetails,
                    testObjects[j].testDetails.isPanel ? 'panel' : 'single'
                );
                reqInfo.orderIds = subOrderIds;
                if (insuranceId) {
                    reqInfo.patientInsuranceId = insuranceId;
                }
                if (medicationIds && medicationIds.length) {
                    reqInfo.medicationIds = medicationIds;
                }
                let createPanelOrSinglePromise = new Promise((resolve, reject) => {
                    saveRequisitionChanges(reqInfo)
                        .then((response) => {
                            resolve(response.data._id);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
                let orderId = await createPanelOrSinglePromise;
                orderIds.push(orderId);
            }
            allMedications = _.uniq([...medicationIds]);
        }
        let reqInfo = this.getParamsForRequisition(
            patientId,
            sampleObjects[0].sample,
            sampleObjects[0].testObjects[0],
            sampleObjects[0].testObjects[0].testDetails,
            'root'
        );
        reqInfo.orderIds = orderIds;
        reqInfo.medicationIds = allMedications;
        if (insuranceId) {
            reqInfo.patientInsuranceId = insuranceId;
        }
        saveRequisitionChanges(reqInfo).then((response) => {
            this.setState({ requisitionPDFPath: response.data.requisition_pdf_path });
            createRequisitionPDF({ orderId: response.data._id }).then((response) => {
                boundActions.endBlockUILoading();
                this.setState({ saving: false, showPrintModal: true });
            });
        });
    };

    getParamsForRequisition = (patientId, sample, testObject, testDetails, orderType) => {
        return {
            testId: testDetails._id,
            providerFirstName: this.state.providerFirstName,
            providerLastName: this.state.providerLastName,
            providerNPI: this.state.providerNPI,
            testInfoCode: testDetails.code,
            testInfoDescription: testDetails.description,
            specimenType: testDetails.specimenType,
            diagnosisCode: testObject.diagnosisCode,
            sample: sample,
            collectedDate: this.state.collectedDate
                ? moment(this.state.collectedDate, '').format('YYYYMMDDHHmmss')
                : '',
            collectorName: this.state.collectorName,
            patientId: patientId,
            facilityId: this.state.facilityId,
            orderDate: moment().format('YYYYMMDDHHmmss'),
            facilityOrderId: sample,
            facilitySource: this.state.facilityName,
            symptoms: orderType === 'root' ? [] : testObject.symptoms,
            orderType: orderType
        };
    };

    hidePrintModal = () => {
        Swal.fire({
            title: 'Did you Print?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ showPrintModal: false });
                this.props.context.componentParent.loadGridData();
                this.handleClose();
            }
        });
    };

    printRequisitionPDF = () => {
        window.open(
            serviceConstants.API_HOST_NAME +
                '/files/requisitionPDF/' +
                this.state.requisitionPDFPath +
                '?' +
                new Date().getTime() +
                '&token=' +
                getUserAuthToken()
        );
    };

    render() {
        return (
            <ModalStyled
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.handleClose}
                onEnter={this.loadDataForModal}
                backdrop="static"
                dialogClassName="removeTabIndexModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Create Toxicology Requisition &nbsp;
                        {this.state.step === 'beforePatient' && '(Select Test and Facility)'}
                        {this.state.step === 'selectPatient' && '(Select Patient)'}
                        {this.state.step === 'selectInsurance' && '(Select Insurance)'}
                        {this.state.step === 'afterInsurance' && '(Final)'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        {this.state.step === 'beforePatient' && (
                            <div className="row form-row">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <TextField
                                            select
                                            label="Facility *"
                                            name="facilityId"
                                            value={this.state.facilityId}
                                            onChange={this.handleChange}
                                        >
                                            {this.state.facilities &&
                                                this.state.facilities.map((fac) => {
                                                    return (
                                                        <MenuItem value={fac._id} key={fac._id}>
                                                            {fac.name}{' '}
                                                            {fac.archived === 'archived' ? ' ( Archived ) ' : ''}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </TextField>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <TextField
                                            select
                                            label="Physician *"
                                            name="selectedProviderId"
                                            value={this.state.selectedProviderId}
                                            onChange={this.handleChange}
                                        >
                                            {this.state.providers &&
                                                this.state.providers.map((prov) => {
                                                    return (
                                                        <MenuItem value={prov._id} key={prov._id}>
                                                            {prov.first_name + ' ' + prov.last_name}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </TextField>
                                        <div
                                            className={
                                                this.hasError('selectedProviderId') ? 'inline-errormsg' : 'hidden'
                                            }
                                        >
                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                &nbsp;This field is required.
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                {this.state.is_show_collector_name_create_requisition && (
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <Autocomplete
                                                id="patient-box-demo"
                                                options={[]}
                                                value={this.state.collectorName}
                                                onInputChange={(event, newValue) => {
                                                    this.setState({
                                                        collectorName: newValue
                                                    });
                                                }}
                                                freeSolo
                                                getOptionLabel={(option) => (option ? option : '')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        label="Name of Collector *"
                                                    />
                                                )}
                                            />
                                            <div
                                                className={
                                                    this.hasError('collectorName') ? 'inline-errormsg' : 'hidden'
                                                }
                                            >
                                                <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                    &nbsp;This field is required.
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <MobileDateTimePicker
                                            value={this.state.collectedDate}
                                            onChange={(dateTime) =>
                                                this.handleDateFiltersChange(dateTime.$d, 'collectedDate')
                                            }
                                            renderInput={(props) => (
                                                <TextField
                                                    {...props}
                                                    className=""
                                                    label="Collection Date *"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton edge="end">
                                                                    <EventIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            )}
                                        />
                                        <div className={this.hasError('collectedDate') ? 'inline-errormsg' : 'hidden'}>
                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                &nbsp;This field is incorrect.
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                {this.state.sampleObjects.map((sampleObject, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="col-12 border border-secondary w-100 p-2 rounded rounded-lg mt-2"
                                        >
                                            <div className="row form-row">
                                                <div className="col-12">
                                                    <h5 className="my-2 mb-3">
                                                        Sample #{index + 1}{' '}
                                                        <i
                                                            className="fas fa-times-circle ml-2 cursorPointer"
                                                            onClick={() => {
                                                                let sampleObjects = this.state.sampleObjects;
                                                                sampleObjects.splice(index, 1);
                                                                this.setState({
                                                                    sampleObjects: sampleObjects
                                                                });
                                                            }}
                                                        ></i>
                                                    </h5>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="form-group">
                                                        <TextField
                                                            select
                                                            label="Specimen Type *"
                                                            name="specimenType"
                                                            value={sampleObject.specimenType}
                                                            onChange={(e) => this.handleChangeSampleObject(e, index)}
                                                        >
                                                            {specimenTypes.map((specimenType) => {
                                                                return (
                                                                    <MenuItem value={specimenType} key={specimenType}>
                                                                        {specimenType}
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        </TextField>
                                                        <div
                                                            className={
                                                                this.hasError('specimenType' + index)
                                                                    ? 'inline-errormsg'
                                                                    : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="form-group">
                                                        <TextField
                                                            label="Sample *"
                                                            name="sample"
                                                            value={sampleObject.sample}
                                                            onChange={(e) => {
                                                                this.handleChangeSampleObject(e, index);
                                                            }}
                                                        />
                                                        <div
                                                            className={
                                                                this.hasError('sample' + index)
                                                                    ? 'inline-errormsg'
                                                                    : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                        <div
                                                            className={
                                                                this.hasError('sampleLength' + index)
                                                                    ? 'inline-errormsg'
                                                                    : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;Sample ID must be at least 6 characters.
                                                            </i>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <BarcodeScanner
                                                                handleChange={(e) =>
                                                                    this.handleChangeSampleObject(e, index)
                                                                }
                                                            />
                                                            <button
                                                                className="btn btn-primary button-info-grid"
                                                                type="button"
                                                                onClick={() => this.autoGenerateKey(index)}
                                                            >
                                                                Auto Generate
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="w-100 border rounded-lg mx-2 p-3 mb-2">
                                                    <div className="row form-row">
                                                        <div className="col-12 my-2">
                                                            <h6>
                                                                Medications{' '}
                                                                <span className="ml-2">
                                                                    <i
                                                                        className="fa fa-plus-circle cursorPointer"
                                                                        onClick={() => {
                                                                            let sampleObjects =
                                                                                this.state.sampleObjects;
                                                                            sampleObjects.map(
                                                                                (sampleObject, sampleObjectIndex) => {
                                                                                    if (index === sampleObjectIndex) {
                                                                                        sampleObject.medications.push({
                                                                                            medication: '',
                                                                                            diagnosisCodes: ['']
                                                                                        });
                                                                                    }
                                                                                    return null;
                                                                                }
                                                                            );
                                                                            this.setState({
                                                                                sampleObjects: sampleObjects
                                                                            });
                                                                        }}
                                                                    ></i>
                                                                </span>
                                                            </h6>
                                                        </div>
                                                        {sampleObject.medications.map((medication, medicationIndex) => {
                                                            return (
                                                                <div className="col-12" key={medicationIndex}>
                                                                    <div className="form-group d-flex align-items-center">
                                                                        <Autocomplete
                                                                            fullWidth
                                                                            freeSolo
                                                                            options={this.state.allMedications}
                                                                            getOptionLabel={(option) =>
                                                                                typeof option === 'string'
                                                                                    ? option
                                                                                    : option.name || ''
                                                                            }
                                                                            value={
                                                                                this.state.allMedications.find(
                                                                                    (med) =>
                                                                                        med._id ===
                                                                                        medication.medication
                                                                                ) ||
                                                                                medication.medicationName ||
                                                                                ''
                                                                            }
                                                                            onChange={(event, newValue) => {
                                                                                this.handleMedicationAutocompleteChange(
                                                                                    newValue,
                                                                                    index,
                                                                                    medicationIndex
                                                                                );
                                                                            }}
                                                                            loading={this.state.loadingMedications}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    label={
                                                                                        'Medication ' +
                                                                                        (medicationIndex + 1)
                                                                                    }
                                                                                    placeholder="Type to search or add new medication by pressing enter key"
                                                                                />
                                                                            )}
                                                                            renderOption={(props, option) => (
                                                                                <li {...props}>
                                                                                    {typeof option === 'string'
                                                                                        ? `Add "${option}"`
                                                                                        : option.name}
                                                                                </li>
                                                                            )}
                                                                        />
                                                                        <span className="mx-2">
                                                                            <i
                                                                                className="fa fa-times-circle cursorPointer"
                                                                                onClick={() => {
                                                                                    let sampleObjects =
                                                                                        this.state.sampleObjects;
                                                                                    sampleObjects.map(
                                                                                        (
                                                                                            sampleObject,
                                                                                            sampleObjectIndex
                                                                                        ) => {
                                                                                            if (
                                                                                                sampleObjectIndex ===
                                                                                                index
                                                                                            ) {
                                                                                                sampleObject.medications.splice(
                                                                                                    medicationIndex,
                                                                                                    1
                                                                                                );
                                                                                            }
                                                                                            return null;
                                                                                        }
                                                                                    );
                                                                                    this.setState({
                                                                                        sampleObjects: sampleObjects
                                                                                    });
                                                                                }}
                                                                            ></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                                <div className="w-100 border rounded-lg mx-2 p-2">
                                                    {sampleObject.testObjects.map((testObject, testObjectIndex) => {
                                                        return (
                                                            <div
                                                                className={
                                                                    'row form-row ' +
                                                                    (testObjectIndex === 0
                                                                        ? ''
                                                                        : 'border rounded-lg p-2 m-2')
                                                                }
                                                                key={testObjectIndex}
                                                            >
                                                                {testObjectIndex === 0 && (
                                                                    <div className="col-12 my-2">
                                                                        <h6>Primary Test</h6>
                                                                    </div>
                                                                )}
                                                                {testObjectIndex !== 0 && (
                                                                    <div className="col-12 my-2">
                                                                        <h6>
                                                                            ADDITIONAL TEST #{testObjectIndex} (USING
                                                                            SAME SAMPLE){' '}
                                                                            <i
                                                                                className="fas fa-times-circle ml-2 cursorPointer"
                                                                                onClick={() => {
                                                                                    let sampleObjects =
                                                                                        this.state.sampleObjects;
                                                                                    sampleObjects.map(
                                                                                        (
                                                                                            sampleObject,
                                                                                            sampleObjectIndex
                                                                                        ) => {
                                                                                            if (
                                                                                                index ===
                                                                                                sampleObjectIndex
                                                                                            ) {
                                                                                                sampleObject.testObjects.splice(
                                                                                                    testObjectIndex,
                                                                                                    1
                                                                                                );
                                                                                            }
                                                                                            return null;
                                                                                        }
                                                                                    );
                                                                                    this.setState({
                                                                                        sampleObjects: sampleObjects
                                                                                    });
                                                                                }}
                                                                            ></i>
                                                                        </h6>
                                                                    </div>
                                                                )}
                                                                <div className="col-12 col-md-6">
                                                                    <div className="form-group">
                                                                        <TextField
                                                                            select
                                                                            label="Test *"
                                                                            name="testId"
                                                                            value={testObject.testId}
                                                                            onChange={(e) =>
                                                                                this.handleChangeTestObject(
                                                                                    e,
                                                                                    index,
                                                                                    testObjectIndex
                                                                                )
                                                                            }
                                                                        >
                                                                            <MenuItem value="" key="">
                                                                                Please select test
                                                                            </MenuItem>
                                                                            {this.state.facilityDetails &&
                                                                                this.state.facilityDetails.testIds &&
                                                                                this.state.facilityDetails.testIds
                                                                                    .length > 0 &&
                                                                                this.state.facilityDetails.testIds.map(
                                                                                    (test) => {
                                                                                        if (
                                                                                            (this.props.testId &&
                                                                                                (this.props.testId ===
                                                                                                    test._id ||
                                                                                                    test.testIds.includes(
                                                                                                        this.props
                                                                                                            .testId
                                                                                                    ))) ||
                                                                                            (!this.props.testId &&
                                                                                                test.specimenType ===
                                                                                                    sampleObject.specimenType)
                                                                                        ) {
                                                                                            return (
                                                                                                <MenuItem
                                                                                                    value={test._id}
                                                                                                    key={test._id}
                                                                                                >
                                                                                                    {test.name}
                                                                                                </MenuItem>
                                                                                            );
                                                                                        }
                                                                                        return null;
                                                                                    }
                                                                                )}
                                                                        </TextField>
                                                                        <div
                                                                            className={
                                                                                this.hasError(
                                                                                    'testId' +
                                                                                        index.toString() +
                                                                                        testObjectIndex.toString()
                                                                                )
                                                                                    ? 'inline-errormsg'
                                                                                    : 'hidden'
                                                                            }
                                                                        >
                                                                            <i
                                                                                className="fa fa-exclamation-circle"
                                                                                aria-hidden="true"
                                                                            >
                                                                                &nbsp;This field is required.
                                                                            </i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6">
                                                                    <div className="form-group">
                                                                        <TextField
                                                                            label="Test Description"
                                                                            name="testId"
                                                                            value={testObject.testInfoDescription}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {this.state
                                                                    .is_show_diagnosis_code_for_tests_create_requisition && (
                                                                    <div className="col-12 col-md-6">
                                                                        <div className="form-group">
                                                                            <Autocomplete
                                                                                multiple
                                                                                options={this.state.allDiagnosisCodes}
                                                                                value={
                                                                                    testObject.diagnosisCode
                                                                                        .map((code) =>
                                                                                            this.state.allDiagnosisCodes.find(
                                                                                                (item) =>
                                                                                                    `${item.code} ${item.description}` ===
                                                                                                    code
                                                                                            )
                                                                                        )
                                                                                        .filter(Boolean) || []
                                                                                }
                                                                                onChange={(event, newValue) => {
                                                                                    const diagnosisCodes = newValue.map(
                                                                                        (item) =>
                                                                                            `${item.code} ${item.description}`
                                                                                    );
                                                                                    this.handleChangeTestObject(
                                                                                        {
                                                                                            target: {
                                                                                                name: 'diagnosisCode',
                                                                                                value: diagnosisCodes
                                                                                            }
                                                                                        },
                                                                                        index,
                                                                                        testObjectIndex
                                                                                    );
                                                                                }}
                                                                                getOptionLabel={(option) =>
                                                                                    option
                                                                                        ? `${option.code} ${option.description}`
                                                                                        : ''
                                                                                }
                                                                                filterOptions={(options, state) => {
                                                                                    const inputValue = state.inputValue
                                                                                        .toLowerCase()
                                                                                        .trim();

                                                                                    // Require at least 2 characters to start filtering
                                                                                    if (inputValue.length < 2) {
                                                                                        return [];
                                                                                    }

                                                                                    // Filter results
                                                                                    const filtered = options.filter(
                                                                                        (option) =>
                                                                                            option.code
                                                                                                .toLowerCase()
                                                                                                .includes(inputValue) ||
                                                                                            option.description
                                                                                                .toLowerCase()
                                                                                                .includes(inputValue)
                                                                                    );

                                                                                    // Return only first 100 matches for performance
                                                                                    return filtered.slice(0, 100);
                                                                                }}
                                                                                noOptionsText={
                                                                                    this.state.allDiagnosisCodes
                                                                                        .length === 0
                                                                                        ? 'Loading diagnosis codes...'
                                                                                        : 'Type at least 2 characters to search'
                                                                                }
                                                                                loading={
                                                                                    this.state.allDiagnosisCodes
                                                                                        .length === 0
                                                                                }
                                                                                renderOption={(
                                                                                    props,
                                                                                    option,
                                                                                    { selected }
                                                                                ) => (
                                                                                    <li {...props} key={option.code}>
                                                                                        <Checkbox
                                                                                            style={{ marginRight: 8 }}
                                                                                            checked={selected}
                                                                                        />
                                                                                        <div>
                                                                                            <strong>
                                                                                                {option.code}
                                                                                            </strong>{' '}
                                                                                            - {option.description}
                                                                                        </div>
                                                                                    </li>
                                                                                )}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        variant="outlined"
                                                                                        label="Diagnosis Code For Visit *"
                                                                                        placeholder="Type to search diagnosis codes"
                                                                                        helperText="Type at least 2 characters to search. You can select multiple codes."
                                                                                    />
                                                                                )}
                                                                                disableCloseOnSelect
                                                                                className={
                                                                                    this.hasError('diagnosisCode')
                                                                                        ? 'is-invalid'
                                                                                        : ''
                                                                                }
                                                                            />
                                                                            <div
                                                                                className={
                                                                                    this.hasError(
                                                                                        'diagnosisCode' +
                                                                                            index.toString() +
                                                                                            testObjectIndex.toString()
                                                                                    )
                                                                                        ? 'inline-errormsg'
                                                                                        : 'hidden'
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className="fa fa-exclamation-circle"
                                                                                    aria-hidden="true"
                                                                                >
                                                                                    &nbsp;This field is required.
                                                                                </i>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="col-12 col-md-6">
                                                                    <div className="form-group">
                                                                        <FormControl
                                                                            variant="outlined"
                                                                            style={{
                                                                                width: '100%'
                                                                            }}
                                                                        >
                                                                            <InputLabel>Symptoms</InputLabel>
                                                                            <Select
                                                                                value={testObject.symptoms}
                                                                                onChange={(e) =>
                                                                                    this.handleChangeTestObject(
                                                                                        e,
                                                                                        index,
                                                                                        testObjectIndex
                                                                                    )
                                                                                }
                                                                                label="Symptoms"
                                                                                className={
                                                                                    this.hasError('symptoms')
                                                                                        ? 'select is-invalid'
                                                                                        : ''
                                                                                }
                                                                                name="symptoms"
                                                                                multiple
                                                                                renderValue={(selected) => {
                                                                                    return selected.join(', ');
                                                                                }}
                                                                            >
                                                                                {testObject.testDetails &&
                                                                                    testObject.testDetails.name &&
                                                                                    testObject.testDetails.symptoms.map(
                                                                                        (symptom) => {
                                                                                            return (
                                                                                                <MenuItem
                                                                                                    key={symptom}
                                                                                                    value={symptom}
                                                                                                >
                                                                                                    <Checkbox
                                                                                                        checked={
                                                                                                            testObject.symptoms.includes(
                                                                                                                symptom
                                                                                                            )
                                                                                                                ? true
                                                                                                                : false
                                                                                                        }
                                                                                                    />
                                                                                                    {symptom}
                                                                                                </MenuItem>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </Select>
                                                                            <div
                                                                                className={
                                                                                    this.hasError('diagnosisCode')
                                                                                        ? 'inline-errormsg'
                                                                                        : 'hidden'
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className="fa fa-exclamation-circle"
                                                                                    aria-hidden="true"
                                                                                >
                                                                                    &nbsp;This field is required.
                                                                                </i>
                                                                            </div>
                                                                        </FormControl>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                <div className="col-12 mt-3">
                                                    <div
                                                        className="btn btn-info w-100"
                                                        onClick={() => {
                                                            let sampleObjects = this.state.sampleObjects;
                                                            sampleObjects.map((sampleObject, sampleObjectIndex) => {
                                                                if (index === sampleObjectIndex) {
                                                                    sampleObject.testObjects.push({
                                                                        testId: '',
                                                                        testDetails: {},
                                                                        testInfoCode: '',
                                                                        testInfoDescription: '',
                                                                        diagnosisCode: [],
                                                                        symptoms: []
                                                                    });
                                                                }
                                                                return null;
                                                            });
                                                            this.setState({
                                                                sampleObjects: sampleObjects
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-plus mr-2"></i>
                                                        Add another test using same sample
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="col-12 mt-3">
                                    <div
                                        className="btn btn-primary w-100"
                                        onClick={() => {
                                            let sampleObjects = this.state.sampleObjects;
                                            sampleObjects.push({
                                                specimenType: this.state.default_specimen_type || '',
                                                sample: '',
                                                medications: [
                                                    {
                                                        medication: '',
                                                        diagnosisCodes: ['']
                                                    }
                                                ],
                                                testObjects: [
                                                    {
                                                        testId: '',
                                                        testDetails: {},
                                                        testInfoCode: '',
                                                        testInfoDescription: '',
                                                        diagnosisCode: [],
                                                        symptoms: []
                                                    }
                                                ]
                                            });
                                            this.setState({
                                                sampleObjects: sampleObjects
                                            });
                                        }}
                                    >
                                        <i className="fas fa-plus mr-2"></i>
                                        {this.state.sampleObjects.length > 0 ? 'Add another sample' : 'Add sample'}
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.step === 'selectPatient' && (
                            <div className="row form-row">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <TextField
                                            label="First Name *"
                                            name="patientFirstName"
                                            value={this.state.patientFirstName}
                                            disabled={this.state.checkPatient}
                                            onChange={this.handleChange}
                                        />
                                        <div
                                            className={this.hasError('patientFirstName') ? 'inline-errormsg' : 'hidden'}
                                        >
                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                &nbsp;This field is required.
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <TextField
                                            label="Last Name *"
                                            name="patientLastName"
                                            value={this.state.patientLastName}
                                            disabled={this.state.checkPatient}
                                            onChange={this.handleChange}
                                        />
                                        <div
                                            className={this.hasError('patientLastName') ? 'inline-errormsg' : 'hidden'}
                                        >
                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                &nbsp;This field is required.
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className="form-group"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end'
                                        }}
                                    >
                                        {!this.state.checkPatient && (
                                            <Button
                                                variant="secondary"
                                                onClick={this.handleBack}
                                                style={{ marginRight: '10px' }}
                                            >
                                                Back
                                            </Button>
                                        )}
                                        <Button variant="info" onClick={this.handleClearCheckPatient}>
                                            Clear above info
                                        </Button>
                                        <Button
                                            variant={this.state.checkPatient ? 'secondary' : 'primary'}
                                            onClick={this.handleCheckPatient}
                                            disabled={this.state.checkPatient ? true : false}
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Check Existing Patient with above info
                                        </Button>
                                    </div>
                                </div>
                                {this.state.checkPatient && (
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <FormControl component="fieldset">
                                                        <FormLabel
                                                            style={{
                                                                marginBottom: '0px'
                                                            }}
                                                        >
                                                            Patient <abbr className="text-danger">*</abbr>
                                                        </FormLabel>
                                                        <RadioGroup
                                                            aria-label="Patient *"
                                                            name="patientCase"
                                                            value={this.state.patientCase}
                                                            onChange={this.handleChange}
                                                            style={{
                                                                flexDirection: 'row',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <FormControlLabel
                                                                key="existing"
                                                                value="existing"
                                                                disabled
                                                                control={<Radio />}
                                                                label="Existing Patient"
                                                            />
                                                            <FormControlLabel
                                                                key="new"
                                                                value="new"
                                                                control={<Radio />}
                                                                label="New Patient"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                    {this.state.patients.length > 0 && (
                                                        <p className="text-info">
                                                            Patient Match found, please click arrow on right to select
                                                            patient in dropdown
                                                        </p>
                                                    )}
                                                    {this.state.patients.length === 0 && (
                                                        <p className="text-info">
                                                            No patient found, please create new patient.
                                                        </p>
                                                    )}
                                                    {this.state.patientCase === 'existing' && (
                                                        <Autocomplete
                                                            id="patient-box-demo"
                                                            options={this.state.patients}
                                                            value={this.state.existingPatient}
                                                            onChange={(event, newValue) => {
                                                                if (newValue && newValue._id) {
                                                                    this.setState({
                                                                        existingPatient: newValue,
                                                                        patientFirstName: newValue.first_name,
                                                                        patientLastName: newValue.last_name,
                                                                        gender: newValue.gender,
                                                                        phoneNumber: newValue.mobile,
                                                                        email: newValue.email,
                                                                        is_pregnant: newValue.hasOwnProperty(
                                                                            'is_pregnant'
                                                                        )
                                                                            ? newValue.is_pregnant
                                                                            : false,
                                                                        dateOfBirth: moment(
                                                                            newValue.date_of_birth
                                                                        ).format('MM/DD/YYYY'),
                                                                        ethnicity: newValue.ethnicity
                                                                            ? newValue.ethnicity
                                                                            : '',
                                                                        race: newValue.race ? newValue.race : '',
                                                                        errors: [],
                                                                        address1:
                                                                            newValue.address &&
                                                                            newValue.address.address1
                                                                                ? newValue.address.address1
                                                                                : '',
                                                                        address2:
                                                                            newValue.address &&
                                                                            newValue.address.address2
                                                                                ? newValue.address.address2
                                                                                : '',
                                                                        city:
                                                                            newValue.address && newValue.address.city
                                                                                ? newValue.address.city
                                                                                : '',
                                                                        state:
                                                                            newValue.address && newValue.address.state
                                                                                ? newValue.address.state
                                                                                : '',
                                                                        zip:
                                                                            newValue.address && newValue.address.zip
                                                                                ? newValue.address.zip
                                                                                : '',
                                                                        passport: newValue.passport
                                                                            ? newValue.passport
                                                                            : '',
                                                                        customInfo: newValue.custom_info
                                                                            ? newValue.custom_info
                                                                            : '',
                                                                        driverLicense: newValue.driver_license,
                                                                        driverLicenseState:
                                                                            newValue.driver_license_state
                                                                    });

                                                                    if (
                                                                        newValue.patient_insurance_ids &&
                                                                        newValue.patient_insurance_ids.length
                                                                    ) {
                                                                        let insurances = newValue.patient_insurance_ids;
                                                                        this.setState({
                                                                            insurances: insurances
                                                                        });
                                                                    } else {
                                                                        this.setState({
                                                                            insurances: []
                                                                        });
                                                                    }
                                                                } else {
                                                                    const temp = {
                                                                        patientFirstName: this.state.patientFirstName,
                                                                        patientLastName: this.state.patientLastName,
                                                                        dateOfBirth: this.state.dateOfBirth
                                                                    };
                                                                    this.initPatient();
                                                                    this.setState(temp);
                                                                }
                                                            }}
                                                            getOptionLabel={(option) =>
                                                                option.first_name
                                                                    ? option.first_name +
                                                                      ' ' +
                                                                      option.last_name +
                                                                      (option.mrn
                                                                          ? ' (mrn: ' +
                                                                            option.mrn +
                                                                            ', birthday: ' +
                                                                            moment(
                                                                                option.date_of_birth,
                                                                                'YYYY-MM-DD'
                                                                            ).format('MM/DD/YYYY') +
                                                                            ', email: ' +
                                                                            option.email +
                                                                            ', mobile: ' +
                                                                            option.mobile +
                                                                            ')'
                                                                          : '')
                                                                    : ''
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Existing Patient"
                                                                    variant="outlined"
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                    <div
                                                        className={
                                                            this.hasError('existingPatient')
                                                                ? 'inline-errormsg'
                                                                : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is required.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Facility Name *"
                                                        name="facilityName"
                                                        value={this.state.facilityName}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <MobileDatePicker
                                                        value={this.state.dateOfBirth}
                                                        onChange={(dateTime) =>
                                                            this.handleDateFiltersChange(dateTime.$d, 'dateOfBirth')
                                                        }
                                                        maxDate={new Date()}
                                                        renderInput={(props) => (
                                                            <TextField
                                                                {...props}
                                                                label="Date of Birth *"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton edge="end">
                                                                                <EventIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {this.state.showDatePickerError && (
                                                        <div className="inline-errormsg">
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;Please select correctly
                                                            </i>
                                                        </div>
                                                    )}
                                                    <div
                                                        className={
                                                            this.hasError('dateOfBirth') ? 'inline-errormsg' : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is incorrect.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <MenuItem onClick={this.togglePregnancy}>
                                                        <Checkbox checked={this.state.is_pregnant} />
                                                        <div
                                                            style={{
                                                                whiteSpace: 'break-spaces'
                                                            }}
                                                        >
                                                            Pregnancy
                                                        </div>
                                                    </MenuItem>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        select
                                                        label="Gender *"
                                                        name="gender"
                                                        value={this.state.gender}
                                                        onChange={this.handleChange}
                                                    >
                                                        {identity.map((identity, index) => {
                                                            return (
                                                                <MenuItem key={index} value={identity.value}>
                                                                    {identity.gender}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </TextField>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Phone Number *"
                                                        name="phoneNumber"
                                                        value={this.state.phoneNumber}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div
                                                        className={
                                                            this.hasError('phoneNumberOrEmail')
                                                                ? 'inline-errormsg'
                                                                : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;Phone number is required.
                                                        </i>
                                                    </div>
                                                    <div
                                                        className={
                                                            this.hasError('wrongPhoneNumber')
                                                                ? 'inline-errormsg'
                                                                : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This is invalid phone number.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Email"
                                                        name="email"
                                                        value={this.state.email}
                                                        onChange={this.handleChange}
                                                    />
                                                    {/* <div
                                                        className={
                                                            this.hasError('phoneNumberOrEmail')
                                                                ? 'inline-errormsg'
                                                                : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;At least one of phone or email is required.
                                                        </i>
                                                    </div> */}
                                                    <div
                                                        className={
                                                            this.hasError('wrongEmail') ? 'inline-errormsg' : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This is invalid email.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Address 1 *"
                                                        name="address1"
                                                        value={this.state.address1}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div
                                                        className={
                                                            this.hasError('address1') ? 'inline-errormsg' : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is required.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Address 2"
                                                        name="address2"
                                                        value={this.state.address2}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="City *"
                                                        name="city"
                                                        value={this.state.city}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div
                                                        className={this.hasError('city') ? 'inline-errormsg' : 'hidden'}
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is required.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        select
                                                        label="State *"
                                                        name="state"
                                                        value={this.state.state}
                                                        onChange={this.handleChange}
                                                    >
                                                        {states.map((state) => {
                                                            return (
                                                                <MenuItem key={state.value} value={state.value}>
                                                                    {state.state}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </TextField>
                                                    <div
                                                        className={
                                                            this.hasError('state') ? 'inline-errormsg' : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is required.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Zip Code *"
                                                        name="zip"
                                                        value={this.state.zip}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div
                                                        className={this.hasError('zip') ? 'inline-errormsg' : 'hidden'}
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is required.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        select
                                                        label="What is your ethnicity?"
                                                        name="ethnicity"
                                                        value={this.state.ethnicity}
                                                        onChange={this.handleChange}
                                                    >
                                                        {ethnicity.map((item) => {
                                                            return (
                                                                <MenuItem key={item.value} value={item.value}>
                                                                    {item.desc}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </TextField>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <FormControl>
                                                        <FormLabel>What is your race?</FormLabel>
                                                        <div
                                                            className={
                                                                this.hasError('race') ? 'inline-errormsg' : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                        <RadioGroup
                                                            aria-label="Race *"
                                                            name="race"
                                                            value={this.state.race}
                                                            onChange={this.handleChange}
                                                            style={{
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {race.map((race) => {
                                                                return (
                                                                    <FormControlLabel
                                                                        key={race.value}
                                                                        value={race.value}
                                                                        control={<Radio />}
                                                                        label={race.value}
                                                                    />
                                                                );
                                                            })}
                                                        </RadioGroup>
                                                    </FormControl>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Passport"
                                                        name="passport"
                                                        value={this.state.passport}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <TextField
                                                        label="Custom Info"
                                                        name="customInfo"
                                                        value={this.state.customInfo}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {this.state.step === 'selectInsurance' && (
                            <div className="row form-row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>
                                            Please select options <span className="text-danger">*</span>
                                        </label>
                                        <div className={this.hasError('noInsurance') ? 'inline-errormsg' : 'hidden'}>
                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                &nbsp;Please select this field.
                                            </i>
                                        </div>
                                        <RadioGroup
                                            name="radio-buttons-group"
                                            onChange={this.handleSelectInsurance}
                                            value={this.state.selectedInsurance}
                                        >
                                            {this.state.insurances.length > 0 &&
                                                this.state.insurances.map((insurance, index) => {
                                                    if (insurance.is_active) {
                                                        let label = insurance.insurance_provider;
                                                        if (insurance.relation_to_insured) {
                                                            label += ' (' + insurance.relation_to_insured + ')';
                                                        }
                                                        return (
                                                            <FormControlLabel
                                                                key={index}
                                                                value={insurance._id}
                                                                control={<Radio />}
                                                                label={label}
                                                                disabled={/Cares\sAct\s\(Uninsured\)|HRSA\sCOVID-19 Uninsured\sProgram/.test(
                                                                    insurance.insurance_provider
                                                                )}
                                                            />
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            <FormControlLabel
                                                value={'new'}
                                                control={<Radio />}
                                                label={'Create New Insurance'}
                                            />
                                        </RadioGroup>
                                    </div>
                                </div>
                                {this.state.selectedInsurance && this.state.selectedInsurance === 'new' && (
                                    <div className="col-12">
                                        <p>
                                            If possible provide one or the other for this patient. If we are unable to
                                            collect it is possible we will invoice you
                                        </p>
                                        <div className="row form-row">
                                            <div className="col-12 col-md-6">
                                                <div className="form-group">
                                                    <FormLabel>
                                                        Insurance Provider or Self/Pay{' '}
                                                        <abbr className="text-danger">*</abbr>
                                                    </FormLabel>
                                                    <Autocomplete
                                                        id="insurance-provider-field"
                                                        options={this.state.insuranceProviders}
                                                        value={this.state.insuranceProv1}
                                                        onChange={(event, newValue) => {
                                                            this.handleChange({
                                                                target: {
                                                                    value: newValue,
                                                                    name: 'insuranceProv1'
                                                                }
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} variant="outlined" />
                                                        )}
                                                    />
                                                    <div
                                                        className={
                                                            this.hasError('noInsuranceProvider')
                                                                ? 'inline-errormsg'
                                                                : 'hidden'
                                                        }
                                                    >
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                            &nbsp;This field is required.
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                {this.state.insuranceProv1 === 'Other' && (
                                                    <div className="form-group">
                                                        <FormLabel>Insurance Provider (If Other)</FormLabel>
                                                        <input
                                                            type="text"
                                                            value={this.state.insuranceProv2}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            name="insuranceProv2"
                                                        />
                                                        <div
                                                            className={
                                                                this.hasError('noInsuranceProvider2')
                                                                    ? 'inline-errormsg'
                                                                    : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row form-row">
                                            <div className="col-12 col-md-12">
                                                <div className="form-group">
                                                    <FormLabel>Social Security Number</FormLabel>
                                                    <input
                                                        type="number"
                                                        value={this.state.socialSecurityNumber}
                                                        onChange={this.handleChange}
                                                        className={
                                                            this.hasError('socialSecurityNumber')
                                                                ? 'form-control is-invalid'
                                                                : 'form-control'
                                                        }
                                                        name="socialSecurityNumber"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <FormLabel>
                                                        Driver's License # (required for filling an insurance claim)
                                                    </FormLabel>
                                                    <input
                                                        type="text"
                                                        value={this.state.driverLicense}
                                                        onChange={this.handleChange}
                                                        className={
                                                            this.hasError('driverLicense')
                                                                ? 'form-control is-invalid'
                                                                : 'form-control'
                                                        }
                                                        name="driverLicense"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <FormLabel>Driver License State</FormLabel>
                                                    <select
                                                        value={this.state.driverLicenseState}
                                                        onChange={this.handleChange}
                                                        className={'form-control'}
                                                        name="driverLicenseState"
                                                    >
                                                        {states.map((state) => {
                                                            return (
                                                                <option key={state.value} value={state.value}>
                                                                    {state.state}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.insuranceProv1 !== 'Self/Pay' && (
                                            <div className="row form-row">
                                                <div className="col-12 col-md-6">
                                                    <div className="form-group">
                                                        <FormLabel>Insurance Member ID</FormLabel>
                                                        <input
                                                            type="text"
                                                            value={this.state.memberId}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            name="memberId"
                                                        />
                                                        <div
                                                            className={
                                                                this.hasError('memberId') ? 'inline-errormsg' : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="form-group">
                                                        <FormLabel>Insurance Group Number</FormLabel>
                                                        <input
                                                            type="text"
                                                            value={this.state.groupNumber}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            name="groupNumber"
                                                        />
                                                        <div
                                                            className={
                                                                this.hasError('groupNumber')
                                                                    ? 'inline-errormsg'
                                                                    : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <FormLabel>Relation to Insured</FormLabel>
                                                        <select
                                                            value={this.state.relation}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            name="relation"
                                                        >
                                                            {relation.map((item) => {
                                                                return (
                                                                    <option value={item.value} key={item.value}>
                                                                        {item.desc}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        <div
                                                            className={
                                                                this.hasError('relation') ? 'inline-errormsg' : 'hidden'
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                                &nbsp;This field is required.
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.relation !== 'Self' && (
                                                    <>
                                                        <div className="col-12 col-md-6">
                                                            <div className="form-group">
                                                                <FormLabel>Insurance Holder First Name</FormLabel>
                                                                <input
                                                                    type="text"
                                                                    value={this.state.insuredFirstName}
                                                                    onChange={this.handleChange}
                                                                    className="form-control"
                                                                    name="insuredFirstName"
                                                                />
                                                                <div
                                                                    className={
                                                                        this.hasError('insuredFirstName')
                                                                            ? 'inline-errormsg'
                                                                            : 'hidden'
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-exclamation-circle"
                                                                        aria-hidden="true"
                                                                    >
                                                                        &nbsp;This field is required.
                                                                    </i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-6">
                                                            <div className="form-group">
                                                                <FormLabel>Insurance Holder Last Name</FormLabel>
                                                                <input
                                                                    type="text"
                                                                    value={this.state.insuredLastName}
                                                                    onChange={this.handleChange}
                                                                    className="form-control"
                                                                    name="insuredLastName"
                                                                />
                                                                <div
                                                                    className={
                                                                        this.hasError('insuredLastName')
                                                                            ? 'inline-errormsg'
                                                                            : 'hidden'
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-exclamation-circle"
                                                                        aria-hidden="true"
                                                                    >
                                                                        &nbsp;This field is required.
                                                                    </i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {this.state.step === 'afterInsurance' && (
                            <div className="row  form-row">
                                <div className="col-12">
                                    <MenuItem onClick={this.toggleCheckedSign}>
                                        <Checkbox checked={this.state.checkedSign} />
                                        <div
                                            style={{
                                                whiteSpace: 'break-spaces'
                                            }}
                                        >
                                            I authorize this requisition and the use of my electronic signature
                                        </div>
                                    </MenuItem>
                                    <div
                                        className={this.hasError('checkedSign') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;&nbsp;You must check the authorize box before creating/saving a
                                            requisition
                                        </i>
                                    </div>
                                </div>
                            </div>
                        )}
                    </form>
                    <ModalStyled
                        show={this.state.showGeneratedBarcode}
                        onHide={() =>
                            this.setState({
                                showGeneratedBarcode: false
                            })
                        }
                    >
                        <Modal.Header closeButton="true">
                            <Modal.Title>Auto Generated BarCode</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="text-center">{this.state.patientName}</div>
                            <div
                                style={{
                                    display: 'flex'
                                }}
                            >
                                <Barcode value={this.state.respondedSample.toString()} format="CODE39" />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <button
                                    className="btn btn-secondary button-info-grid"
                                    type="button"
                                    onClick={() => {
                                        this.setState({
                                            showGeneratedBarcode: false
                                        });
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </Modal.Body>
                    </ModalStyled>
                    <ModalStyled show={this.state.showPrintModal} onHide={() => this.hidePrintModal()}>
                        <Modal.Header closeButton="true">
                            <Modal.Title>Please Print Necessary Items</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h3 className="text-center mb-3">
                                Thank you, the requisition was created successfully and has been sent to our lab.
                            </h3>
                            <div className="row">
                                <div className="text-center col-12 mb-3">
                                    <button
                                        className="btn btn-info"
                                        type="button"
                                        style={{ width: '250px' }}
                                        onClick={() => {
                                            window.open(
                                                serviceConstants.API_HOST_NAME +
                                                    '/files/barcodeImagePDF/' +
                                                    this.state.sampleObjects[0].sample +
                                                    '.pdf?' +
                                                    new Date().getTime() +
                                                    '&token=' +
                                                    getUserAuthToken()
                                            );
                                        }}
                                    >
                                        <i className="fa fa-barcode" aria-hidden="true"></i> Print Barcode
                                    </button>
                                </div>
                                <div className="text-center col-12 mb-3">
                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        style={{ width: '250px' }}
                                        onClick={() => this.printRequisitionPDF()}
                                    >
                                        <i className="fa fa-file-pdf" aria-hidden="true"></i> Print Requisition PDF
                                    </button>
                                </div>
                                <div className="text-center col-12">
                                    <button
                                        className="btn btn-secondary"
                                        type="button"
                                        style={{ width: '250px' }}
                                        onClick={() => this.hidePrintModal()}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </ModalStyled>
                </Modal.Body>
                {(this.state.step !== 'selectPatient' || this.state.checkPatient) && (
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleBack}>
                            {this.state.step === 'beforePatient' ? 'Close' : 'Back'}
                        </Button>
                        <Button variant="primary" onClick={this.handleNext}>
                            {this.state.saving && (
                                <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }}></i>
                            )}
                            {this.state.step === 'afterInsurance' ? 'Create' : 'Next'}
                        </Button>
                    </Modal.Footer>
                )}
            </ModalStyled>
        );
    }
}
